/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Remove_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo no longer prepares this conversation and writes no report. What is already there is kept." |
*
* @param {Meeting_Remove_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_remove_body = /** @type {((inputs?: Meeting_Remove_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Remove_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo bereidt dit gesprek niet meer voor en schrijft geen verslag. Wat er al staat, blijft bewaard.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo ne prépare plus cette conversation et n'écrit pas de compte rendu. Ce qui existe déjà est conservé.")
	return /** @type {LocalizedString} */ ("Wundo no longer prepares this conversation and writes no report. What is already there is kept.")
});